import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const serviceFeesTiersByTenantQuery = gql`
  query ServiceFeesTiersByTenant($tenantId: ID!, $currency: String) {
    serviceFeesTiersByTenant(currency: $currency, tenantId: $tenantId) {
      uuid
      baseServiceFee
      endValue
      startValue
      tierServiceFee
    }
  }
`

export const serviceFeesByTenantTiersKey = getQueryNames(serviceFeesTiersByTenantQuery)[0]

export default serviceFeesTiersByTenantQuery
